import type { Page } from '@/domain/model/Page';
import type { Activity } from '@/domain/model/Activity';
import type { ActivityGateway, ListActivitiesParams } from '@/application/port/out/ActivityGateway';
import type { ListActivitiesUseCase } from '@/application/port/in/ActivityUseCase';

export class ListActivities implements ListActivitiesUseCase {
  constructor(private readonly g: ActivityGateway) {}
  execute(params: ListActivitiesParams): Promise<Page<Activity>> { return this.g.list(params); }
}
